<script>
    import { slide } from 'svelte/transition'
    import { clickOutside } from '$lib/utils'
    export let open = false
    export let position = 'bottom'
    export let transition = {
        duration: 1000,
        delay: 0,
    }
    export let disabled = false
    export let style = ''
    let { func: ftransition = slide, ...ftparams } = transition
    // console.log({ transition, ftransition, ftparams })
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<span class="main" {style} use:clickOutside on:clickout={() => (open = false)}>
    <span
        class="zone"
        on:click={() => {
            if (!disabled) {
                open = !open
            }
        }}
    >
        <slot name="select" />
    </span>
    {#if open}
        <div
            in:ftransition|local={ftparams}
            out:ftransition|local={ftparams}
            class={`content ${position}`}
            class:open
        >
            <slot />
        </div>
    {/if}
</span>

<style>
    :root {
        --spacing: 10px;
    }

    .main {
        display: flow-root;
        position: relative;
        width: fit-content;
    }
    .zone {
        width: 100%;
        height: fit-content;
        cursor: pointer;
        /* background-color: rgb(25, 122, 90); */
        display: block;
    }
    .content {
        /* background-color: blueviolet; */
        position: absolute;
        width: 100%;
        display: none;
    }
    .bottom {
        top: calc(100% + var(--spacing));
        left: 0;
    }
    .top {
        left: 0;
        bottom: calc(100% + var(--spacing));
    }
    .left {
        top: 0;
        right: calc(100% + var(--spacing));
    }
    .right {
        top: 0;
        left: calc(100% + var(--spacing));
    }

    .open {
        display: inherit;
    }
</style>
